import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Candidate type interface
export interface BulkMailCandidate {
    id: number;
    name: string;
    email: string;
    profile: string | null;
    location: string | null;
    jobTitle: string | null;
    graphProfileId: number | null;
}

// Initial state type
interface CandidateState {
    candidates: BulkMailCandidate[];
    talentPool: number | null;
    showMail: null | boolean;
    showScreening: null | boolean;
    showCampaign: null | boolean;
}

const initialState: CandidateState = {
    candidates: [],
    talentPool: null,
    showMail: null,
    showScreening: null,
    showCampaign: null,
};

const candidateBulkMail = createSlice({
    name: "candidateScreening",
    initialState,
    reducers: {

        replaceReduxCandidates(state, action: PayloadAction<BulkMailCandidate | BulkMailCandidate[]>) {
            const candidates = Array.isArray(action.payload) ? action.payload : [action.payload];
            state.candidates = candidates;
        },
        addCandidates(state, action: PayloadAction<BulkMailCandidate | BulkMailCandidate[]>) {
            const candidates = Array.isArray(action.payload) ? action.payload : [action.payload];
            candidates.forEach(candidate => {
                const index = state.candidates.findIndex(c => c.id === candidate.id);
                if (index !== -1) {
                    state.candidates.splice(index, 1);
                } else {
                    state.candidates.push(candidate);
                }
            });

        },

        removeCandidates(state, action: PayloadAction<number | number[]>) {
            const idsToRemove = Array.isArray(action.payload) ? action.payload : [action.payload];
            state.candidates = state.candidates.filter(
                (candidate) => !idsToRemove.includes(candidate.id)
            );
        },

        setBulkMailTalentPool(state, action: PayloadAction<number | null>) {
            state.talentPool = action.payload;
        },
        setShowMail(state, action: PayloadAction<boolean | null>) {
            state.showMail = action.payload;
        },
        setShowScreening(state, action: PayloadAction<boolean | null>) {
            state.showScreening = action.payload;
        },
        setShowCampaign(state, action: PayloadAction<boolean | null>) {
            state.showCampaign = action.payload;
        },
    },
});

export const {
    replaceReduxCandidates,
    addCandidates,
    removeCandidates,
    setBulkMailTalentPool,
    setShowMail,
    setShowScreening,
    setShowCampaign
} = candidateBulkMail.actions;

export default candidateBulkMail.reducer;
